import React from 'react';
import ContainerHeader from '../components/ContainerHeader';
import { ColumnDirective, ColumnsDirective, Filter, GridComponent, Group } from '@syncfusion/ej2-react-grids';
import { Inject, Page, Sort, Search, Toolbar } from '@syncfusion/ej2-react-grids';
import { Button } from '@material-ui/core';
import { useMemo } from 'react';
import useManagingStoresController from './CustomHooks/useManagingStoresController';
import ViewStockTransactions from './components/ViewStockTransactions';
import AddStockTransactions from './components/AddStockTransactions';
import { dateTemplate } from '../GenTask/components/SharedFormFields';
function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}
class DebugBoundary extends React.Component {
  state = { hasError: false };
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(error, info) {
    console.error('ErrorBoundary caught error:', error, info);
  }
  render() {
    if (this.state.hasError) return <div>Error in grid rendering</div>;
    return this.props.children;
  }
}

const ManagingStoresPage = props => {
  const pageSettings = useMemo(
    () => ({
      pageSize: 30,
      pageSizes: [5, 10, 20, 30, 40],
    }),
    [],
  );
  const filterSettings = {
    type: 'Excel',
  };
  const {
    poData,
    handleConsume,
    viewFormDialog,
    handleAddDialogClose,
    currentData,
    stockTransaction,
  } = useManagingStoresController();

  const handleActionBegin = args => {
    if (args.requestType === 'beginEdit' || args.requestType === 'save') {
    }
  };

  const contextMenuClick = args => {};
  const toolbarOptions = [{ text: 'Search', tooltipText: 'Search', prefixIcon: 'e-search', id: 'search' }];

  function consumeTemplate(props) {
    return (
      <Button
        key={`${props.id}_site`}
        style={{ color: 'blue', fontWeight: 'bold', width: '100%', fontSize: 12 }}
        onClick={() => handleConsume(props)}>
        Consume
      </Button>
    );
  }

  return (
    <div className="app-wrapper siteWrapper">
      <ContainerHeader match={props.match} title={'Managing Stores'} />

      <div style={{ height: 'calc(100vh - 80px)', width: '100%', paddingTop: '0.5rem' }}>
        <DebugBoundary>
          <GridComponent
            dataSource={poData}
            filterSettings={filterSettings}
            allowPaging={true}
            pageSettings={pageSettings}
            allowSorting={true}
            allowTextWrap={true}
            allowResizing={true}
            allowMultiSorting={true}
            allowReordering={true}
            allowFiltering={true}
            style={{
              minHeight: 'auto !important',
            }}
            actionBegin={handleActionBegin}
            height="100%"
            toolbar={toolbarOptions}>
            <ColumnsDirective>
              {/* <ColumnDirective
                field="id"
                headerText="View Details"
                width="80"
                textAlign="Left"
                isPrimaryKey={true}
                template={editLinkTemplate}
              /> */}
              <ColumnDirective field="ordeR_NUMBER" headerText="Order Number" width="100" />
              <ColumnDirective field="stocK_CODE" headerText="Stock Code" width="100" />
              <ColumnDirective field="description" headerText="Description" width="90" />
              <ColumnDirective field="depT_NUMBER" headerText="Dept. Number" width="90" />
              <ColumnDirective field="depT_NAME" headerText="Department Name" width="120" />
              <ColumnDirective field="qtY_ORDER" headerText="Qty Ordered" width="90" />
              <ColumnDirective field="qtY_DELIVERED" headerText="Qty Delivered" width="90" />
              <ColumnDirective field="qtY_REMAINING" headerText="Qty Remaining" width="95" />
              <ColumnDirective field="uniT_PRICE" headerText="Unit Price" width="80" textAlign="Right" />
              <ColumnDirective
                field="deliverY_DATE"
                headerText="Delivered On"
                width="80"
                type="datetime"
                formatter={dateTemplate}
              />
              <ColumnDirective field="transactions" headerText="Transactions" width="100" />
              <ColumnDirective field="neT_AMOUNT" headerText="Net Amount" width="100" />
              <ColumnDirective field="deliveryStatus" headerText="Delivery Status" width="100" />
              <ColumnDirective field="action" headerText="Action" width="100" template={consumeTemplate} />
            </ColumnsDirective>
            <Inject services={[Page, Sort, Filter, Group, Search, Toolbar]} />
          </GridComponent>
        </DebugBoundary>
      </div>

      <AddStockTransactions
        viewFormDialog={viewFormDialog}
        handleAddDialogClose={handleAddDialogClose}
        currentData={currentData}
        stockTransaction={stockTransaction}
        handleConsume={handleConsume}
      />
    </div>
  );
};

export default ManagingStoresPage;
